// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"88":"uploadDeviceFile","664":"findShip"}[chunkId] + "." + {"88":"cfd36179","664":"31f12be7"}[chunkId] + ".css";
};